import { BarChart2 } from "lucide-react";
import { AnalyticsDashboardRoute } from "./routes/AnalyticsDashboardRoute";

export const ANALYTICS_ROUTES = {
  analytics: {
    key: "analytics",
    path: "/analytics",
    title: "Analytics",
    icon: <BarChart2 size={17} />,
    element: <AnalyticsDashboardRoute />
  }
};
